'use strict';

var React = require('react');

var SvgShareIosMinor = function SvgShareIosMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.293 6.703a.997.997 0 0 0 1.414 0l1.293-1.294v6.589a1 1 0 1 0 2 0v-6.589l1.293 1.294a1 1 0 1 0 1.414-1.415l-3-3.001a.994.994 0 0 0-.298-.198c-.027-.013-.055-.021-.082-.03l-.012-.003a.944.944 0 0 0-.257-.05l-.027-.002a.937.937 0 0 0-.385.06c-.004 0-.008 0-.012.002a.028.028 0 0 0-.013.003h-.004a1.002 1.002 0 0 0-.294.197c-.004.004-.01.007-.015.01l-.015.01-3 3.002a1 1 0 0 0 0 1.415zm-2.793 2.297a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-3.5v2h3v5h-12v-5h3v-2h-3.5z"
  }));
};

exports.SvgShareIosMinor = SvgShareIosMinor;
